<div class="page-header">
  <ng-container
    *ngIf="{
      pageName: pageName$ | async,
      templateName: templateName$ | async,
    } as content"
  >
    <h1>
      @if (content.templateName === 'SearchResultsListPageTemplate' || content.templateName === 'SearchResultsGridPageTemplate') {
        {{ 'category.search.title' | cxTranslate }}
      }
      <span>
        {{ content.pageName }}
      </span>
      <span *ngIf="currentTerm">Results for: "{{ currentTerm }}" </span>
    </h1>
  </ng-container>
</div>
